module.exports = __webpack_public_path__ + "img/room_football_bg.b7852914.png";